import styled from 'styled-components';
import { BaseContainer } from '../Containers';

import { breakpoints } from '../../constants';

export const SwipeContainer = styled(BaseContainer)`
    flex: 1;
    display: flex;
    flex-direction: column;
    position: static;
    margin: 60px auto 0;
    width: 100%;
    align-self: center;

    @media (${breakpoints.mediumMin}) {
        display: none;
    }
`;
